export enum PosSyncType {
  LIGHTSPEED = 'lightspeed_k_series',
  SIMPHONY = 'simphony',
}
